import { render } from "./InstallerLayout.vue?vue&type=template&id=6c3f6e67&scoped=true"
import script from "./InstallerLayout.vue?vue&type=script&lang=js"
export * from "./InstallerLayout.vue?vue&type=script&lang=js"

import "./installer-layout.scss?vue&type=style&index=0&id=6c3f6e67&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/installer/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c3f6e67"]])

export default __exports__